<script setup>
import {computed} from 'vue'
import moment from 'moment'

const props = defineProps({
    oldValue: Number,
    newValue: Number,
    dateFormat: String
})

const oldDate = computed(() => {
    return moment(props.oldValue * 1000).format('DD MMM YYYY, HH:mm')
})

const newDate = computed(() => {
    return moment(props.newValue * 1000).format('DD MMM YYYY, HH:mm')
})
</script>

<template>
    <div class="d-flex align-items-center">
        <small v-if="oldDate" class="border rounded py-1 px-2" v-html="oldDate"></small>
        <i v-else class="small">empty</i>

        <i class="mx-2 bi-chevron-right"/>

        <small v-if="newDate" class="border rounded py-1 px-2" v-html="newDate"></small>
        <i v-else class="small">empty</i>
    </div>
</template>